/**
 * Generated by orval v7.2.0 🍺
 * Do not edit manually.
 * BVHI Product Data Platform
 * The backend service api is responsible for managing users, customer data, product catalogs, and api token.
 * OpenAPI spec version: 1.28.12
 */

/**
 * The status of the Catalog specification.
 */
export type PublicationStatus =
  (typeof PublicationStatus)[keyof typeof PublicationStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PublicationStatus = {
  DRAFT: "DRAFT",
  PUBLISHED: "PUBLISHED",
  DELETED: "DELETED",
} as const;
